/**
 *  获取四舍五入的值-以解决四舍五入精度问题
 * @param {Object} value
 * @param {Object} how
 */
const fNumRound = (value, how) => {
	let num = new Number(value);
	let num1 = new Number(num.toFixed(10));
	return parseFloat(num1.toFixed(how));
};

/**
 * @Description: 解决JS计算浮点加法时的精度问题
 * @errorExample: 0.7+0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumAdd = (arg1, arg2) => {
	let r1 = 0;
	let r2 = 0;
	let m = 0;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}

	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}

	m = Math.pow(10, Math.max(r1, r2));
	return (arg1 * m + arg2 * m) / m;
};

/**
 * @Description: 解决JS计算浮点减法时的精度问题
 * @errorExample: 0.3/0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumDesc = (arg1, arg2) => {
	let r1 = 0;
	let r2 = 0;
	let m = 0;
	let n = 0;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	n = (r1 >= r2) ? r1 : r2;
	return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/**
 * @Description: 解决JS计算浮点乘法时的精度问题
 * @errorExample: 0.045 * 1293.00
 * @param arg1
 * @param arg2
 * @return
 */
const fNumMul = (arg1, arg2) => {
	let m = 0;
	let s1 = arg1.toString();
	let s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length;
	} catch (e) {}

	try {
		m += s2.split(".")[1].length;
	} catch (e) {}

	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};



/**
 * @Description: 解决JS计算浮点除法时的精度问题
 * @errorExample: 0.3/0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumDiv = (arg1, arg2) => {
	let t1 = 0;
	let t2 = 0;
	let r1 = 0;
	let r2 = 0;
	try {
		t1 = arg1.toString().split(".")[1].length;
	} catch (e) {}
	try {
		t2 = arg2.toString().split(".")[1].length;
	} catch (e) {}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	return (r1 / r2) * Math.pow(10, t2 - t1);
};

// 金额格式化
const fMoneyFat = (value, decimalPlaces = 2) => {
  // 将输入值转换为数字
  value = Number(value);
  
  // 处理无效值情况
  if (isNaN(value)) return '-';
  if (value === null || value === undefined) return '-';
  
  // 确定最终要保留的小数位数
  let precision;
  
  // 限制最多只保留4位小数
  if (decimalPlaces >= 0) {
    // 如果显式指定了小数位数，最多取4位
    precision = Math.min(decimalPlaces, 4);
  } else {
    // 自动模式：根据原始值的小数位数决定，但最多4位
    const valueStr = value.toString();
    const parts = valueStr.split('.');
    const hasDecimalPart = parts.length === 2;
    const originalDecimalLength = hasDecimalPart ? parts[1].length : 0;
    
    if (hasDecimalPart) {
      if (originalDecimalLength >= 5) {
        // 对于像3.12345这样的5位以上小数，四舍五入到4位
        precision = 4;
      } else if (originalDecimalLength >= 2) {
        // 对于2位以上小数，保留实际有意义的位数，但最多4位
        precision = Math.min(originalDecimalLength, 4);
      } else {
        // 对于少于2位小数，保持原样
        precision = originalDecimalLength;
      }
    } else {
      // 整数的话，默认保留到2位小数
      precision = 2;
    }
  }
  
  // 格式化数字并四舍五入到指定位数
  // 使用toFixed进行四舍五入，确保3.12345能正确变为3.1235
  let formatted = Number(value).toFixed(precision);
  
  // 移除末尾多余的零，但保留实际有意义的小数位
  // 例如3.1200会变成3.12，同时3.1235会保持不变
  formatted = formatted.replace(/\.?0+$/, '');
  // 如果只剩下小数点，则也移除
  formatted = formatted.replace(/\.$/, '');
  
  // 检查是否至少有两位小数，如果没有则补零
  const formattedParts = formatted.split('.');
  if (formattedParts.length === 1) {
    // 整数情况，补两位小数
    formatted += '.00';
  } else if (formattedParts[1].length < 2) {
    // 小数位数少于两位，补零到两位
    formatted += '0'.repeat(2 - formattedParts[1].length);
  } else if (formattedParts[1].length > 4) {
    // 额外检查：如果小数位超过4位，则四舍五入到4位
    const tempNum = Number(formatted);
    formatted = tempNum.toFixed(4);
    // 再次去除末尾多余的零
    formatted = formatted.replace(/\.?0+$/, '');
    formatted = formatted.replace(/\.$/, '');
    // 确保仍然至少有两位小数
    const parts = formatted.split('.');
    if (parts.length === 1) {
      formatted += '.00';
    } else if (parts[1].length < 2) {
      formatted += '0'.repeat(2 - parts[1].length);
    }
  }
  
  return formatted;
};

// 判断数字（包含正负整数，0以及正负浮点数）如果是数字返回输入，不是返回 ''
const fIsNum = (arg) => {
	arg = arg.toString();
	let argChar = '0123456789.';
	let pointNum = 0;

	if (arg.length < 1) return '0';

	//如果第一个字符是0 截取  从第二个字符开始（包含）
	if (arg.charAt(0) == '0' && arg.charAt(0) != '.')
		arg = arg.substring(1);

	//如果第一个字符是 .
	if (arg.charAt(0) == '.')
		arg = '0' + arg;

	for (let i = 0; i < arg.length; i++) {
		if (arg.substring(i, i + 1) == '.') pointNum = pointNum + 1;
		if (argChar.indexOf(arg.substring(i, i + 1)) == -1) return '';
	};

	if (pointNum > 1) return '';
	return arg;
};

export default {

	fNumAdd, //加
	fNumDesc, //减
	fNumMul, //乘
	fNumDiv, //除
	fNumRound, //四舍五入

	fMoneyFat, //金额格式化
	fIsNum,// 判断数字（包含正负整数，0以及正负浮点数）如果是数字返回输入，不是返回 ''

};



//////////////////
// WEBPACK FOOTER
// ./common/global/numHelper.js
// module id = null
// module chunks = 